// @flow

import * as React from "react";
import { useDispatch } from "react-redux";

import actions from "../actions/";

const useCheckoutNav = (disable: boolean) => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        if (!disable) {
            dispatch(actions.setCheckoutNav());
        }

        return function cleanup() {
            dispatch(actions.unsetCheckoutNav());
        };
    }, []); //eslint-disable-line
};

export default useCheckoutNav;
